import { Button, Input, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import type { ComplexFilters } from "../../api/complexes/complexes.types";
import { Filter } from "lucide-react";

interface ComplexesFilterProps {
  onFilter: (data: ComplexFilters) => void;
  onClear: () => void;
  initialFilters?: Partial<ComplexFilters>;
}

export const ComplexesFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: ComplexesFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<ComplexFilters>({
    defaultValues: {
      fantasyName: initialFilters?.fantasyName ?? "",
      cnpj: initialFilters?.cnpj ?? "",
      responsibleName: initialFilters?.responsibleName ?? "",
    },
  });

  const handleFilter = (data: ComplexFilters) => {
    onFilter(data);
  };

  const handleClear = () => {
    form.reset();
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("management.complexes.form.label.complex")}:`}
            name="fantasyName"
            type="text"
            placeholder={translate(
              "management.complexes.form.placeholder.filterComplex",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.complexes.form.label.cnpj")}:`}
            name="cnpj"
            type="text"
            placeholder={translate(
              "management.complexes.form.placeholder.cnpj",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.complexes.form.label.responsible")}:`}
            name="responsibleName"
            type="text"
            placeholder={translate(
              "management.complexes.form.placeholder.filterResponsible",
            )}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("management.complexes.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("management.complexes.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
